import { render, staticRenderFns } from "./WaitingForTv.vue?vue&type=template&id=345e4574&scoped=true"
import script from "./WaitingForTv.vue?vue&type=script&lang=js"
export * from "./WaitingForTv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345e4574",
  null
  
)

export default component.exports